// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getData = createAsyncThunk('payment/getData', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/paymentsV3', params)
  console.log('ashi1', response.data.allData.length)
  console.log('ashi2', response.data.data.length)
  return response.data
})

export const addProduct = createAsyncThunk(
  'payment/addProduct',
  async (params, { dispatch, getState }) => {
    await axios.post('https://api.fntpf.ir/add/adminProducts', params)
    await dispatch(getData(getState().permissions.params))
    return params
  }
)

export const updateProduct = createAsyncThunk(
  'payment/updateProduct',
  async (params, { dispatch, getState }) => {
    await axios.post('https://api.fntpf.ir/add/adminProducts', params)
    await dispatch(getData(getState().permissions.params))
    return { id, name }
  }
)

export const deletePermission = createAsyncThunk('payment/deletePermission', async (id, { dispatch, getState }) => {
  console.log('ID: ', id)
  await axios.post('https://api.fntpf.ir/delete/products', id)
  await dispatch(getData(getState().permissions.params))
  return id
})

export const paymentSlice = createSlice({
  name: 'payment',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selected: null
  },
  reducers: {
    selectPayment: (state, action) => {
      if (action.payload === null) {
        state.selected = null
      } else {
        state.selected = action.payload
      }
    }
  },
  extraReducers: builder => {
    builder.addCase(getData.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.total = action.payload.allData.length
      state.params = action.payload.params
      state.allData = action.payload.allData
    })
  }
})

export const { selectPayment } = paymentSlice.actions

export default paymentSlice.reducer
